import { render } from "./LargeScreen.vue?vue&type=template&id=36cd4ccc&scoped=true"
import script from "./LargeScreen.vue?vue&type=script&lang=js"
export * from "./LargeScreen.vue?vue&type=script&lang=js"

import "./LargeScreen.vue?vue&type=style&index=0&id=36cd4ccc&lang=scss&scoped=true"
import "./LargeScreen.vue?vue&type=style&index=1&id=36cd4ccc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cd4ccc"]])

export default __exports__